import React from 'react'
import { CurrentUser } from 'javascripts/components/CurrentUser/types'

const CurrentUserContext = React.createContext<Partial<CurrentUser>>({})

export default CurrentUserContext
